"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageView = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const RelativeTimeChip_1 = __importDefault(require("@opsbase/web-chips/RelativeTimeChip"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CloseIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Avatar_1 = __importDefault(require("@opsbase/web-ui/Avatar"));
const Button_1 = require("@opsbase/web-ui/Button");
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const Callout_1 = __importDefault(require("./Callout"));
const makeMyClasses = () => ({
    callOut: {
        paddingTop: 10,
    },
    name: {
        color: lib_palette_1.default.GreyBlue.main,
        fontSize: 12,
        fontFamily: 'Gilroy',
        fontWeight: 'bold',
        paddingBottom: 4,
        '&.self': {
            textAlign: 'right',
        },
        '&.other': {},
    },
    comment: {
        justifyContent: 'flex-end',
        alignItems: 'center',
        '&.self': {
            paddingLeft: 16,
        },
        '&.other': {
            paddingRight: 16,
        },
    },
});
function MessageView(props) {
    const { comment, commentor, isSelf, timezone, onDeleteComment, onEditComment, onCancelEditComment, commentIndex, editable, editing, firstItem, lastItem, simpleCallouts, refProp, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleDeleteComment = (0, react_1.useCallback)(() => onDeleteComment(comment, commentIndex), [
        comment,
        commentIndex,
        onDeleteComment,
    ]);
    const handleEditComment = (0, react_1.useCallback)(() => onEditComment(comment, commentIndex), [
        comment,
        commentIndex,
        onEditComment,
    ]);
    const handleCancelEditComment = (0, react_1.useCallback)(() => onCancelEditComment(comment, commentIndex), [
        comment,
        commentIndex,
        onCancelEditComment,
    ]);
    return (react_1.default.createElement("div", { style: {
            backgroundColor: editing && editable ? lib_palette_1.default.OJ.background : undefined,
            paddingTop: firstItem ? 16 : 0,
        }, ref: refProp },
        editing ? (react_1.default.createElement(Button_1.Button, { tiny: true, style: {
                borderColor: lib_palette_1.default.OJ.main,
                backgroundColor: lib_palette_1.default.OJ.lighten(0.6).toString(),
                borderWidth: 2,
                borderRadius: 20,
                marginLeft: 8,
            }, onClick: handleCancelEditComment },
            react_1.default.createElement(CloseIcon_1.default, { color: lib_palette_1.default.OJ }))) : null,
        react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', reverse: isSelf },
            !simpleCallouts ? (react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', style: {
                    flex: 0,
                    alignItems: 'flex-end',
                    marginRight: 10,
                    marginLeft: 10,
                    marginBottom: lastItem ? 24 : 0,
                    visibility: !lastItem ? 'hidden' : undefined,
                } },
                react_1.default.createElement(Avatar_1.default, { user: commentor, allowEdit: false, size: 24 }))) : null,
            react_1.default.createElement(Vertical_1.default, null,
                !simpleCallouts && commentor && firstItem ? (react_1.default.createElement(core_1.Typography, { className: myCss.name + (isSelf ? ' self' : ' other') }, commentor.title)) : null,
                comment.deleted ? (react_1.default.createElement(Text_1.default, { style: {
                        textAlign: isSelf ? 'right' : 'left',
                        color: lib_palette_1.default.BlackCoral.main,
                        margin: 16,
                        marginBottom: 8,
                    } }, lib_i18n_1.default.t('issue-comment-deleted'))) : (react_1.default.createElement(Callout_1.default, { variant: isSelf ? 'self' : 'other', text: comment.title, photos: comment.photos, edited: comment.edited, onEditPress: !editing && editable && isSelf && comment
                        ? handleEditComment
                        : undefined, onDeletePress: !editing && editable && isSelf ? handleDeleteComment : undefined, fullSize: simpleCallouts })),
                !simpleCallouts && lastItem ? (react_1.default.createElement(RelativeTimeChip_1.default, { time: comment.commentDate, timezone: timezone, textStyle: {
                        color: lib_palette_1.default.InputBorderGrey.main,
                        textAlign: isSelf ? 'right' : 'left',
                        fontSize: 12,
                        paddingTop: 4,
                    } })) : null))));
}
exports.MessageView = MessageView;
exports.default = MessageView;
